
const features = [
  {
    icon: 'ri-focus-3-line',
    title: 'Precision Cutting',
    description: 'Achieve accuracy within 0.01mm with our advanced laser positioning system.'
  },
  {
    icon: 'ri-speed-line',
    title: 'High Speed',
    description: 'Up to 1200mm/s engraving speed for maximum productivity.'
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Safety First',
    description: 'Enclosed design with emergency stop and safety interlocks.'
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '24/7 Support',
    description: 'Global technical support team ready to assist anytime.'
  },
  {
    icon: 'ri-tools-line',
    title: 'Easy Maintenance',
    description: 'Modular design for simple maintenance and part replacement.'
  },
  {
    icon: 'ri-cloud-line',
    title: 'Smart Control',
    description: 'Intuitive software with cloud connectivity and remote monitoring.'
  }
];

const FeaturesSection = () => {
  return (
    <section className="py-24 bg-gray-900 relative overflow-hidden">
      <div className="absolute inset-0 opacity-30">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-emerald-500 rounded-full filter blur-3xl"></div>
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-emerald-600 rounded-full filter blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="text-center mb-16">
          <span className="text-emerald-400 font-semibold text-sm tracking-wider uppercase">
            Why Choose Us
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-white mt-3 mb-4">
            Built for Excellence
          </h2>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto">
            Over 20 years of innovation and engineering excellence in every machine we build.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="
                group
                p-8
                bg-white bg-opacity-5
                backdrop-blur-sm
                rounded-2xl
                border border-white border-opacity-10
                hover:bg-white hover:bg-opacity-10
                hover:border-emerald-500 hover:border-opacity-50
                transition-all duration-300
              "
            >
              <div
                className="
                  w-14 h-14
                  bg-emerald-500 bg-opacity-20
                  rounded-xl
                  flex items-center justify-center
                  mb-6
                  group-hover:bg-emerald-500
                  transition-colors
                "
              >
                <i
                  className={`
                    ${feature.icon}
                    text-2xl
                    text-emerald-400
                    group-hover:text-white
                    transition-colors
                  `}
                ></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-3">{feature.title}</h3>
              <p className="text-gray-400 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
